import React from 'react'

import dayjs from 'dayjs'
import { Property } from '../../service/cart'

export interface Props {
  property: Property
}

const PropertyIntro: React.FunctionComponent<Props> = (props) => {
  const { property } = props
  const arrivalDate = dayjs(property.arrival.date, 'YYYY-MM-DD')
  const departureDate = dayjs(property.departure.date, 'YYYY-MM-DD')
  const nights = Math.abs(arrivalDate.diff(departureDate, 'days'))
  const dateFormat = 'ddd DD MMMM YYYY'

  return <>
    <img className="checkout_guest__img" src={property.img} />
    <h4>{property.name}</h4>
    <span>{arrivalDate.format(dateFormat)} to {departureDate.format(dateFormat)} ({nights} nights)</span>
  </>
}

export default PropertyIntro

